// About.jsx - Modernized About Page
import React from 'react';
import './About.css';

const About = () => {
  const features = [
    {
      icon: '🛰️',
      title: 'پایش ماهواره‌ای',
      description: 'دسترسی به دقیق‌ترین تصاویر ماهواره‌ای Sentinel و Landsat برای رصد تغییرات پوشش گیاهی.',
    },
    {
      icon: '🤖',
      title: 'هوش مصنوعی',
      description: 'پردازش خودکار داده‌ها با الگوریتم‌های یادگیری ماشین جهت پیش‌بینی عملکرد محصول.',
    },
    {
      icon: '💧',
      title: 'مدیریت منابع آب',
      description: 'محاسبه شاخص‌های تبخیر و تعرق جهت بهینه‌سازی مصرف آب در مزارع.',
    },
    {
      icon: '📜',
      title: 'گزارشات هوشمند',
      description: 'ارائه گزارش‌های تحلیلی و نمودارهای زمانی از روند رشد و سلامت گیاه.',
    },
  ];

  const stats = [
    { label: 'دقت تحلیل', value: '98%' },
    { label: 'اراضی تحت پوشش', value: '+10K هکتار' },
    { label: 'به‌روزرسانی', value: '5 روزه' },
  ];

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-title animate-fade-up">تحول هوشمند در <span className="text-accent">کشاورزی مدرن</span></h1>
          <p className="hero-subtitle animate-fade-up-delay">
            ما با تلفیق تکنولوژی فضایی و دانش کشاورزی، آینده‌ای پایدار برای امنیت غذایی می‌سازیم.
          </p>
        </div>
      </section>

      <div className="about-container">
        {/* Stats Bar */}
        <section className="stats-bar">
          {stats.map((stat, idx) => (
            <div key={idx} className="stat-item">
              <span className="stat-value">{stat.value}</span>
              <span className="stat-label">{stat.label}</span>
            </div>
          ))}
        </section>

        {/* Mission Section */}
        <section className="about-mission">
          <div className="mission-text">
            <h2>ماموریت ما</h2>
            <p>
              در دنیای امروز که با چالش‌های کم‌آبی و تغییرات اقلیمی روبروست، هدف ما توانمندسازی کشاورزان و مدیران اراضی با داده‌های دقیق است. ما پیچیدگی‌های تصاویر ماهواره‌ای را به راهکارهای ساده و قابل درک تبدیل می‌کنیم تا بهره‌وری را افزایش و ریسک‌های تولید را کاهش دهیم.
            </p>
          </div>
          <div className="mission-visual">
             <div className="visual-circle"></div>
             <div className="visual-icon">🌍</div>
          </div>
        </section>

        {/* Features Grid */}
        <section className="about-features">
          <div className="section-header">
            <h2>چرا پلتفرم ما؟</h2>
            <div className="underline"></div>
          </div>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon-wrapper">
                  <span className="feature-icon">{feature.icon}</span>
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Tech Stack - Modern Layout */}
        <section className="about-tech">
          <h2>تکنولوژی‌های پیشرفته</h2>
          <div className="tech-grid">
            <div className="tech-box">
              <div className="tech-tag">GIS & Remote Sensing</div>
              <p>استفاده از شاخص‌های NDVI، EVI و NDWI برای تحلیل دقیق سلامت گیاه.</p>
            </div>
            <div className="tech-box">
              <div className="tech-tag">Cloud Processing</div>
              <p>پردازش سریع داده‌های حجیم ماهواره‌ای در بستر کلاود.</p>
            </div>
            <div className="tech-box">
              <div className="tech-tag">Big Data</div>
              <p>مدیریت و فراخوانی متادیتاهای تخصصی برای هر شاخص در دایرکتوری‌های مجزا.</p>
            </div>
          </div>
        </section>

        {/* Call to Action or Team */}
        <section className="about-footer-cta">
          <h2>همراه ما باشید</h2>
          <p>تیم ما متشکل از متخصصین سنجش از دور و برنامه‌نویسان خلاق، آماده پشتیبانی از پروژه‌های شماست.</p>
          <button className="cta-button">شروع تجربه هوشمند</button>
        </section>
      </div>
    </div>
  );
};

export default About;